module.exports = __webpack_public_path__ + "media/images/common/logo-footer-53580ef25b746f27cb58aaefcac17118.svg";